import { Static, Type } from '@sinclair/typebox';
import { makeNullable } from '../../../utils/typeboxHelpers';

export const surveyCommentTableSchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
    text: Type.String(),
    topic: Type.String(),
    commentedBy: Type.String(),
    commentedOn: Type.String(),
    surveyId: Type.String({ format: 'uuid' }),
    created_at: Type.String(),
    updated_at: Type.String(),
    isArchived: Type.Boolean(),
    /** Reference to the user who commented. Set to NULL if user is deleted. */
    commentedById: makeNullable(Type.String({ format: 'uuid' })),
});

/** Comments regarding the handling of the survey. Part of workflow and only used internally. */
export type SurveyComment = Static<typeof surveyCommentTableSchema>;
